/**
 * /*
 *
 * @format
 * @Description:
 * @Author: changfu
 * @Date: 2020-06-10 20:34:19
 * @LastEditTime: 2020-06-12 09:54:44
 * @LastEditors:
 */

/** @format */
import logLogin from './logLogin';
import applicationResources from './applicationResources';
import organization from './organization'
import userList from './userList'
import common from './common'
import roleList from './roleList'
import dataAuth from './dataAuth'

const enList = { ...applicationResources, ...logLogin, ...organization, ...userList, ...common, ...roleList, ...dataAuth };
const zh_CN = {
  "basic": {
    "code-001": "关闭所有",//关闭所有
    "code-002": "关闭其它",//关闭所有
    "code-003": "切换标签",
    "code-004": "测试下拉内容",
    "code-005": "请输入关键字",
    "code-006": "云徙科技 版权所有",

    "code-007": "设置成功",
    "code-008": "发送验证码成功",
    "code-009": "未知的发送短信验证码错误",
    "code-0010": "手机号不能为空",
    "code-0011": "手机号格式错误",
    "code-0012": "获取验证码",
    "code-0013": "验证码",
    "code-0014": "请输入您的验证码",
    "code-0015": "提交",
    "code-0016": "重置",
    "code-0017": "手机号码",
    "code-0018": "请输入您的手机号码",

    "code-0019": "未知的重置密码异常",
    "code-0020": "修改密码需要先登录",
    "code-0021": "注销成功",
    "code-0022": "修改密码",
    "code-0023": "注销",
    "code-0024": "重置密码",
    "code-0025": "新密码",
    "code-0026": "请输入您的新密码",
    "code-0027": "密码必须为6-18位数字、字母或下划线_组成",
    "code-0028": "确认密码",
    "code-0029": "重新输入密码",
    "code-0030": "两次输入不一致",

    "code-0031": "未知的登录异常",
    "code-0032": "加载用户信息...",
    "code-0033": "ARM框架",
    "code-0034": "请填写用户名",
    "code-0035": "请填写密码",
    "code-0036": "请填写验证码",
    "code-0037": "登录",
    "code-0038": "云徙科技有限公司",
    
    "code-0039": "找不到页面",

    "code-0040": "Admin管理端"
  },
  appName: {
    loc: '泰啤运营平台(本地环境)',
    dev: '泰啤运营平台(开发环境)',
    demo: '泰啤运营平台',
    test: '泰啤运营平台(测试环境)',
    stage: '泰啤运营平台(集成环境)'
  },
  header : {
    newMessage: '新消息',
    onlineSupport: '在线服务',
    hotlineSupport: '热线服务',
    application: '应用'
  },
  login: {
    account: {
      placeholeder: '请输入用户名',
      nulltips: '请填写用户名'
    },
    pwd: {
      placeholeder: '请输入密码',
      nulltips: '请填写密码'
    },
    vertifiCode: {
      placeholeder: '请输入验证码',
      error: '图形验证码无效'
    },
    btn: {
      text: '登录'
    },
    copy: {
      name: '云徙科技有限公司'
    }
  },
  productList: {
    'code-0001': '用户名',
    'code-0002': '用户身份',
    'code-0003': '待办事项',
    'code-0004': '今日新增事项',
    'code-0005': '待办事项日统计',
    'code-0006': '各应用菜单资源访问次数和时长统计（图表） - 按月累计',
    'code-0007': '访问人数累计和占比',
    'code-0008': '应用管理员'
  },
  tenantDetail: {
    'code-0001': '租户信息',
    'code-0002': '租户编号',
    'code-0003': '租户名称',
    'code-0004': '租户管理员账号',
    'code-0005': '租户管理员联系方式',
    'code-0006': '已授权应用',
    'code-0007': '应用编号',
    'code-0008': '应用名称',
    'code-0009': '应用模板',
    'code-0010': '访问入口',
    'code-0011': '状态',
    'code-0012': '查看',
    'code-0013': '禁用',
    'code-0014': '查询条件',
    'code-0015': '用户名',
    'code-0016': '创建时间',
    'code-0017': '租户管理员列表',
    'code-0018': '新增管理员',
    'code-0019': '姓名',
    'code-0020': '手机号码',
    'code-0021': '邮箱',
    'code-0022': '编辑',
    'code-0023': '禁用',
    'code-0024': '修改密码',
    'code-0025': '删除',
    'code-0026': '启用',
    'code-0027': '新增租户管理员',
    'code-0028': '编辑租户管理员',
    'code-0029': '确定',
    'code-0030': '取消',
    'code-0031': '新密码',
    'code-0032': '确认新密码',
    'code-0033': '密码',
    'code-0034': '请输入租户管理员用户名',
    'code-0035': '请输入登录密码',
    'code-0036': '请输入租户管理员姓名',
    'code-0037': '请输入手机号码',
    'code-0038': '请输入邮箱',
    'code-0039': '请输入租户管理员用户名！',
    'code-0040': '密码不能为空',
    'code-0041': '姓名不能为空',
    'code-0042': '用户名只能输入数字，字母、中划线或下划线，限20字符以内',
    'code-0043': '密码为数字、字母、特殊符号两种及以上组合',
    'code-0044': '姓名长度不能大于20个字符',
    'code-0045': '手机号码有误',
    'code-0046': '请输入正确的邮箱格式',
    'code-0047': '新密码不能为空',
    'code-0048': '确认新密码不能为空',
    'code-0049': '密码为数字、字母、特殊符号两种及以上组合',
    'code-0050': '请输入新密码'
  }
};

export default { ...zh_CN, ...enList };



// WEBPACK FOOTER //
// ./src/config/langs/zh_CN/index.js